export default __webpack_public_path__ + "static/media/persons.cc9da7f6.svg";